import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LocationsPage from '@pages/locations/LocationsPage';
import LocationViewPage from '@pages/locations/LocationViewPage';
import LocationEditPage from '@pages/locations/LocationEditPage';
import LocationCreatePage from '@pages/locations/LocationCreatePage';

export const LocationsRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<LocationsPage />} />
            <Route path="/create" element={<LocationCreatePage />} />
            <Route path="/:id" element={<LocationViewPage />} />
            <Route path="/:id/edit" element={<LocationEditPage />} />
        </Routes>
    );
};

export default LocationsRoutes;
